import React, { Component } from "react";
import "./CorporateProductView.css";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";
import { showCorporateProductView, doCorporateProductViewRes } from "../../../action/CorporateProductViewAction";
import { addToCartCorporate, doCorporateAddToCartRes } from "../../../action/CorporateAddToCartAction";
import { showCorporateCartList, doCorporateCartListRes } from "../../../action/CorporateCartListAction";
import { UploadImageCustomize, doImageUploadCustomize } from '../../../action/ImageUploadCustomizeAction';
import Footer from "../../../component/Footer/Footer";
import CorporateLayoutWrapper from "../../../component/CorporateLayoutWrapper/";
// import Swal from 'sweetalert2'
import { Link } from "react-router-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import LoginRegister from "../../LoginRegister/LoginRegister";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import loaderImg from "../../../assets/images/loader-example.gif";
import Loader from "react-loader-advanced";
import parse from "html-react-parser";
import ReactGA from "react-ga";
import { Row, Col } from 'react-bootstrap';
import ReactPixel from "react-facebook-pixel";
// import ImageUploader from 'react-images-upload';
import Swal from 'sweetalert2'
// let isLoadData = false;
// let isLoadDataDetail = false;
class CorporateProductView extends Component {
  constructor(props) {
    super(props);
    // isLoadData = false;
    // isLoadDataDetail = false;
    this.state = {
      productData: [],
      photoData: [],
      qty: 1,
      qtyCat: 1,
      cartCheck: false,
      isImageUpload: false,
      imageUrl: [],
      removeAdd: false,
      isLoader: false,
      colorData: [],
      sizeData: [],
      brandData: [],
      finalVar: [],
      color: '',
      size: '',
    };
    ReactGA.initialize("UA-64201999-5");
    ReactGA.pageview(window.location.pathname + window.location.search);

    ReactPixel.init("784849368913134");

    ReactPixel.pageView();
  }

  componentDidMount() {
    const data = {
      kit_id: this.props.match.params.id,

    };

    this.setState(
      {
        isLoader: true,
      }
    );

    // isLoadData = true;
    // isLoadDataDetail = true;
    this.props.showCorporateProductView(data);
  }

  setQtyCat = (e) => {
    this.setState({
      qtyCat: e
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.doCorporateProductViewRes && nextProps.doCorporateProductViewRes.user) {
      if (nextProps.doCorporateProductViewRes.user && nextProps.doCorporateProductViewRes.user.CorporateProductViewRes) {
        if (nextProps.doCorporateProductViewRes.user.CorporateProductViewRes && nextProps.doCorporateProductViewRes.user.CorporateProductViewRes.results === true) {
          this.setState({
            productData: nextProps.doCorporateProductViewRes.user.CorporateProductViewRes.data,
            colorData: nextProps.doCorporateProductViewRes.user.CorporateProductViewRes.color,
            sizeData: nextProps.doCorporateProductViewRes.user.CorporateProductViewRes.size,
            brandData: nextProps.doCorporateProductViewRes.user.CorporateProductViewRes.brand
          }, () => {
            let photoItemPush = [];
            photoItemPush.push({
              original: this.state.productData.photo,
            });
            this.setState({
              photoData: photoItemPush,
              isLoader: false,
            });
            for (let item of this.state.productData.product) {
              if (item.name === "T-shirt") {
                if (this.state.finalVar.length === 0) {
                  this.setState({
                    finalVar: [{
                      qtyCat: 1,
                      color: '',
                      size: '',
                    }]
                  })
                }
              }
            }

          })
        }
      }
    }

    if (nextProps.doCorporateAddToCartRes && nextProps.doCorporateAddToCartRes.user) {
      if (nextProps.doCorporateAddToCartRes.user && nextProps.doCorporateAddToCartRes.user.CorporateAddToCartRes) {
        if (nextProps.doCorporateAddToCartRes.user.CorporateAddToCartRes && nextProps.doCorporateAddToCartRes.user.CorporateAddToCartRes.result === true &&
          this.state.removeAdd === true) {
          // this.props.history.push('/corporate-product-update')
          this.setState({
            cartCheck: true,
            removeAdd: false,
            isLoader: false,
          }, () => {
            if (this.state.cartCheck) {
              const cartData = {
                user_id: localStorage.getItem("userId"),
              };
              this.props.showCorporateCartList(cartData);
            }
          })
        } else {
          this.setState({
            isLoader: false,
          });
        }
      }
    }

    if (nextProps.doImageUploadCustomize && nextProps.doImageUploadCustomize.data) {
      if (nextProps.doImageUploadCustomize.data && nextProps.doImageUploadCustomize.data.UploadImageRes) {
        if (nextProps.doImageUploadCustomize.data.UploadImageRes && nextProps.doImageUploadCustomize.data.UploadImageRes.success === true && this.state.isImageUpload) {
          this.setState({
            imageUrl: [...this.state.imageUrl, { image: nextProps.doImageUploadCustomize.data.UploadImageRes.URL }],
            isLoader: false,
            isImageUpload: false,

          })
        }
      }
    }
  }





  addtocart = (dataItem) => {
    if (localStorage.getItem("userId")) {
      if (dataItem.corporate_type === 1) {
        const sumQtyData = this.state.finalVar.reduce((result, number) => result + number.qtyCat, 0);
        if (sumQtyData) {

          for (let itemData of this.state.finalVar) {
            if (itemData.color === '' && itemData.size === '') {
              Swal.fire({
                title: "Please select t-shirt color and size",
                icon: 'warning',
                confirmButtonText: 'OK',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 1000
              })
            } else if (itemData.color === '') {
              Swal.fire({
                title: "Please select t-shirt color",
                icon: 'warning',
                confirmButtonText: 'OK',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 1000
              })
            } else if (itemData.size === '') {
              Swal.fire({
                title: "Please select t-shirt size",
                icon: 'warning',
                confirmButtonText: 'OK',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 1000
              })
            } else {
              if (this.state.qty === sumQtyData) {
                const data = {
                  user_id: localStorage.getItem("userId"),
                  product_id: '',
                  kit_id: dataItem.kit_id,
                  qty: this.state.qty,
                  image_json: '',
                  text_json: '',
                  thumbnail: this.state.imageUrl[0].image,
                  thumbnail_back: '',
                  thumbnail_pocket: '',
                  brand: '',
                  model: '',
                  text_data: JSON.stringify(this.state.finalVar),
                };
                this.setState({
                  removeAdd: true,
                  isLoader: true,
                });
                this.props.addToCartCorporate(data);

              } else {
                Swal.fire({
                  title: "Kit qty and t-shirt qty not matched!!!",
                  icon: 'warning',
                  confirmButtonText: 'OK',
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  timer: 1000
                })
              }
            }
          }

        } else {
          const data = {
            user_id: localStorage.getItem("userId"),
            product_id: '',
            kit_id: dataItem.kit_id,
            qty: this.state.qty,
            image_json: '',
            text_json: '',
            thumbnail: this.state.imageUrl[0].image,
            thumbnail_back: '',
            thumbnail_pocket: '',
            brand: '',
            model: '',
            text_data: '',
          };
          this.setState({
            removeAdd: true,
            isLoader: true,
          });
          this.props.addToCartCorporate(data);
        }
      }
    } else {
      this.getValue(true);
    }
  };

  onCloseModal = () => {
    this.setState({
      loginModalPopup: false,
    });
  };

  getValue = (e) => {
    this.setState({
      loginModalPopup: e,
    });
  };


  uploadImage = (e) => {
    if (e.target.files[0].size <= 20971520) {
      const imgData = {
        imageUpload: e.target.files[0]
      }
      this.setState({
        isImageUpload: true,
        isLoader: true
      }, () => {
        this.props.UploadImageCustomize(imgData)
      })
    } else {
      Swal.fire({
        title: "Only 20Mb upload file",
        icon: 'warning',
        confirmButtonText: 'OK',
        showConfirmButton: false,
        allowOutsideClick: false,
        timer: 1000
      })
    }
  }

  remImg = (t) => {
    let d = this.state.imageUrl
    d.splice(t, 1)
    this.setState({
      imageUrl: [...d]
    })
  }

  showErrorPopUp = () => {
    Swal.fire({
      title: "Please Upload File",
      icon: 'warning',
      confirmButtonText: 'OK',
      showConfirmButton: false,
      allowOutsideClick: false,
      timer: 1000
    })
  }

  updateFinalVal = () => {
    let final = this.state.finalVar
    final.push(this.state.finalVar[0])

    this.setState({
      finalVar: [...final]
    })
  }

  removeFinalVal = (i) => {
    let fVal = this.state.finalVar;
    fVal.splice(i, 1)
    this.setState({
      finalVar: [...fVal]
    })
  }

  updateFinalValObject = (t, e, i) => {
    let final = this.state.finalVar[i];
    if (t === 'qty') {
      final = {
        qtyCat: e,
        color: this.state.finalVar[i].color,
        size: this.state.finalVar[i].size,

      }
    } else if (t === 'color') {
      final = {
        qtyCat: this.state.finalVar[i].qtyCat,
        color: e.target.value,
        size: this.state.finalVar[i].size,
      }
    } else if (t === 'size') {
      final = {
        qtyCat: this.state.finalVar[i].qtyCat,
        color: this.state.finalVar[i].color,
        size: e.target.value,
      }
    }
    let d = this.state.finalVar;
    d[i] = final;
    this.setState({
      finalVar: [...d]
    })
  }



  render() {
    const spinner = <span><img src={loaderImg} alt="" /></span>;

    return (
      <React.Fragment>
        <CorporateLayoutWrapper />
        <Loader show={this.state.isLoader} message={spinner}>
          <main className="main main-container">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <div className="container">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={"/corporate-tab"}>Corporate Tab</Link>
                  </li>
                  {/* {this.state.productViewData && this.state.productViewData.map((item,i) =>( */}
                  <li className="breadcrumb-item">

                    <Link to={"#"}>{this.state.productData.name}</Link>
                  </li>
                  {/* ))} */}
                </ol>
              </div>
              {/* End .container */}
            </nav>

            <div className="container">
              {/* {this.state.productViewData.length !== 0 ? ( */}
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-single-container product-single-default">
                    {/* {this.state.productViewData && this.state.productViewData.map((item,i) =>( */}
                    <div className="row">
                      <div className="col-lg-5 col-md-6">
                        <ImageGallery
                          showPlayButton={false}
                          items={this.state.photoData}
                        />
                      </div>

                      <div className="col-lg-7 col-md-6">
                        <div className="product-single-details">
                          <h1 className="product-title font-capital">
                            {this.state.productData.name}
                          </h1>


                          <div className="price-box">
                            <span className="old-price">
                              <i
                                className="fa fa-rupee-sign "
                                aria-hidden="true"
                              ></i>
                              {this.state.productData.price}.00
                            </span>
                            <span className="product-price color-price">
                              <i
                                className="fa fa-rupee-sign"
                                aria-hidden="true"
                              ></i>
                              {this.state.productData.sale_price}.00
                            </span>
                          </div>
                          {/* End .price-box */}


                          <h6 className="product-title fnt-size-h6 ">
                            Products Included:
                          </h6>
                          <div>

                            <ol className="pad-left-25">
                              {
                                this.state.productData && this.state.productData.product && this.state.productData.product.map((item, i) => (
                                  <li className="list-fnt" key={i}>{item.name}</li>
                                ))
                              }

                            </ol>

                          </div>
                          <Row>
                            <div className="col-md-2">
                              <label htmlFor="pa_color" className="qty-label">Photo</label>
                            </div>
                            <div className="col-md-4">
                              <input type="file" className="custom-file-upload" onChange={(e) => this.uploadImage(e)} />
                            </div>

                          </Row>



                          <Row>
                            <Col xs={4}>
                              {
                                this.state.imageUrl.length > 0 &&
                                this.state.imageUrl.map((item, i) => (
                                  <div className="uploadImageCupRemove" key={i}>
                                    <img src={item.image} alt="uploadImg" width="70px" />
                                    <span onClick={() => this.remImg(i)} className="fa fa-trash removeImageCup"></span>
                                  </div>))
                              }
                            </Col>
                          </Row>


                          {
                            this.state.productData && this.state.productData.product && this.state.productData.product.map((item, i) => (
                              item.name === "T-shirt" &&
                              <div key={i}>

                                <div className="col-md-12 mt-3">
                                  <div className="row">
                                    <div className='dip-flex-row'>
                                      <div className="col-md-4">
                                        <label htmlFor="pa_color" className="">Color</label>
                                      </div>
                                      <div className="col-md-4">
                                        <label htmlFor="pa_color" className="">Size</label>
                                      </div>

                                      <div className="col-md-4">
                                        <label htmlFor="pa_color" className="">Qty</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {
                                  this.state.finalVar.map((f, findex) =>
                                    <div className="col-md-12" key={findex}>
                                      <div className="row">
                                        <div className='dip-flex-row'>
                                          <div className='col-md-4'>
                                            <table>
                                              <tbody>
                                                <tr>
                                                  <td className="value size-cmbo">
                                                    <select className="col-md-12 variationsSelect" name='attribute_pa_color' data-attribute_name="attribute_pa_color" data-show_option_none="yes"
                                                      onChange={(e) => this.updateFinalValObject('color', e, findex)}
                                                      value={f.color}
                                                    >
                                                      <option value=''>Select Color</option>
                                                      {
                                                        this.state.colorData.map((item, i) => (
                                                          <option displayname={item.name} value={item.name} className="attached enabled" key={i} >{item.name}</option>
                                                        ))
                                                      }
                                                    </select>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                          <div className='col-md-4'>
                                            <table>
                                              <tbody>
                                                <tr>

                                                  <td className="value size-cmbo">
                                                    <select className="col-md-12 variationsSelect" name='attribute_pa_color' data-attribute_name="attribute_pa_color" data-show_option_none="yes"
                                                      onChange={(e) => this.updateFinalValObject('size', e, findex)}
                                                      value={f.size}
                                                    >
                                                      <option value="">Select Size</option>
                                                      {
                                                        this.state.sizeData.map((item, i) => (
                                                          <option displayname={item.name} value={item.name} className="attached enabled" key={i}>{item.name}</option>
                                                        ))
                                                      }
                                                    </select>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>

                                          <div className='col-md-4'>

                                            <div className="product-action product-all-icons">

                                              <div
                                                className="product-single-qty"
                                                style={{ display: "flex" }}
                                              >

                                                <button
                                                  className="btn btn-outline btn-height"
                                                  disabled={this.state.qtyCat === 1}
                                                  onClick={() => {
                                                    this.setQtyCat(this.state.qtyCat - 1);
                                                    this.updateFinalValObject('qty', this.state.qtyCat - 1, findex)
                                                  }


                                                  }
                                                >
                                                  -
                                                </button>

                                                <input
                                                  className="horizontal-quantity form-control btn-height"
                                                  type="text"
                                                  readOnly
                                                  value={f.qtyCat}
                                                  placeholder="qty"
                                                />
                                                <button
                                                  className="btn btn-outline btn-height"
                                                  onClick={() => {
                                                    this.setQtyCat(this.state.qtyCat < 20 ? this.state.qtyCat + 1 : this.state.qtyCat);
                                                    this.updateFinalValObject('qty', (this.state.qtyCat < 20 ? this.state.qtyCat + 1 : this.state.qtyCat), findex)
                                                  }
                                                  }
                                                >
                                                  +
                                                </button>
                                                {
                                                  findex === 0 ? ''
                                                    : <div className="marg-left">
                                                      <i className="fa fa-minus-circle" onClick={() => this.removeFinalVal(findex)}></i>
                                                    </div>
                                                }

                                              </div>

                                            </div>

                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                  )
                                }

                              </div>
                            ))}
                          {
                            this.state.productData && this.state.productData.product && this.state.productData.product.map((item, i) => (
                              item.name === "T-shirt" &&
                              <div className="flot-right add-more" key={i}>
                                <div className="add-text-dec" onClick={() => this.updateFinalVal()}>Add More</div>
                              </div>
                            ))
                          }


                          <Row>
                            <div className="col-md-2">
                              <label htmlFor="pa_color" className="qty-label">Qty</label>
                            </div>
                            <div className="col-md-4">
                              <div className="product-action product-all-icons">
                                <div
                                  className="product-single-qty"
                                  style={{ display: "flex" }}
                                >

                                  <button
                                    className="btn btn-outline"
                                    disabled={this.state.qty === 1}
                                    onClick={() =>
                                      this.setState({ qty: this.state.qty - 1 })
                                    }
                                  >
                                    -
                                  </button>

                                  <input
                                    className="horizontal-quantity form-control"
                                    type="text"
                                    onChange={(e) =>
                                      parseInt(e.target.value) > 1
                                        ? this.setState({
                                          qty:
                                            e.target.value < 20
                                              ? parseInt(e.target.value)
                                              : 20,

                                        })
                                        : ""
                                    }
                                    disabled
                                    value={this.state.qty}
                                    placeholder="qty"
                                  />

                                  <button
                                    className="btn btn-outline"
                                    onClick={() =>
                                      this.setState({
                                        qty:
                                          this.state.qty < 20
                                            ? this.state.qty + 1
                                            : this.state.qty,

                                      })
                                    }
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                            </div>
                          </Row>
                          {this.state.imageUrl.length === 0 ?
                            <div
                              className="paction add-cart show-color  pointer"
                              title="Add to Cart"
                              onClick={() =>
                                this.showErrorPopUp()
                              }
                            >
                              <span>Add to Cart</span>
                            </div>
                            :
                            <div
                              className="paction add-cart show-color detais-btn pointer"
                              title="Add to Cart"
                              onClick={() =>
                                this.addtocart(this.state.productData)
                              }
                            >
                              <span>Add to Cart</span>
                            </div>
                          }
                          {/* </div> */}

                          <div className="product-single-share">

                          </div>

                        </div>

                      </div>

                    </div>


                  </div>

                  <div className="product-single-tabs">
                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item">
                        <a
                          className="description-a"
                          id="product-tab-desc"
                          data-toggle="tab"
                          href="product.html#product-desc-content"
                          role="tab"
                          aria-controls="product-desc-content"
                          aria-selected="true"
                        >
                          Description
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">

                      <div
                        className="tab-pane fade show active"
                        id="product-desc-content"
                        role="tabpanel"
                        aria-labelledby="product-tab-desc"
                      >
                        <div className="product-desc-content">
                          <div>{parse("" + this.state.productData.description + "")}</div>
                          <div>
                            <h4>
                              For Bulk Order
                              <Link to="/contacts" className="link-transform">
                                &nbsp;Contact Us
                              </Link>
                            </h4>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              </div>
              {/* ) : (
                isLoadData ?? <div className="product-not-show"></div>
              )} */}
            </div>
          </main>
        </Loader>
        {/* End .main */}
        <Modal open={this.state.loginModalPopup} onClose={this.onCloseModal}>
          <LoginRegister getValue={this.getValue} />
        </Modal>

        <Footer />
      </React.Fragment >
    );
  }
}

CorporateProductView.propTypes = {
  doCorporateProductViewRes: PropTypes.any,
  doCorporateAddToCartRes: PropTypes.any,
  doCorporateCartListRes: PropTypes.any,
  doImageUploadCustomize: PropTypes.any,
};

const mapStateToProps = createStructuredSelector({
  doCorporateProductViewRes: doCorporateProductViewRes,
  doCorporateAddToCartRes: doCorporateAddToCartRes,
  doCorporateCartListRes: doCorporateCartListRes,
  doImageUploadCustomize: doImageUploadCustomize
});

function mapDispatchToProps(dispatch) {
  return {
    showCorporateProductView: (data) => dispatch(showCorporateProductView(data)),
    addToCartCorporate: (data) => dispatch(addToCartCorporate(data)),
    showCorporateCartList: (data) => dispatch(showCorporateCartList(data)),
    UploadImageCustomize: (data) => dispatch(UploadImageCustomize(data))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(CorporateProductView);
